import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTopJump = (props) => /* @__PURE__ */ _jsxs("svg", {
	height: 24,
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "m12 10.414 5.293 5.293a1 1 0 0 0 1.414-1.414l-6-6a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414z"
	}), /* @__PURE__ */ _jsx("mask", {
		id: "b",
		fill: "#fff",
		children: /* @__PURE__ */ _jsx("use", {
			fill: "#fff",
			fillRule: "evenodd",
			xlinkHref: "#a"
		})
	})] }), /* @__PURE__ */ _jsxs("g", {
		fill: "#000",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("use", {
			fillRule: "nonzero",
			xlinkHref: "#a"
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#b)",
			children: /* @__PURE__ */ _jsx("path", { d: "m0 0h24v24h-24z" })
		})]
	})]
});
export default SvgTopJump;
